import * as constants from "../../widgetConstants.js";
import * as DashboardApi from "../../../../apiCall/dashboard/index.js";
import {getNoData, setProjectTtl} from "../../items/index.js";
import u from "../../../../util"
import {BridgeSend, isMobile} from "../../event.js";
import {addFilterEvent} from "../filter-popup/index.js";
import {subscribeWidget} from "../../../main-socket/index.js";
import {WIDGET} from "../../widgetConstants.js";
import Widget from "../widget.js";

export class ProjectSummaryWidget extends Widget {

    async setup(props) {
        return super.setup(props);
    }

    async getData(props) {
        if(!this.$props.COLABO_SRNO) return true;

        const inputData = {
            COLABO_SRNO: this.$props.COLABO_SRNO,
            SRCH_USER_ID: this.$props.FIL_END_DT_GUBUN === "2"? _USER_ID : "",
            RGSR_ID: _USER_ID,
            IN_RCVR_USER_ID: _USER_ID
        }
        this.$props.data = await this.getDBData(inputData)
        return true;
    }

    async getDBData(inputData) {
        const data = await DashboardApi.getApi(this.$props.API_KEY, inputData)
        this.$props.pageData.NEXT_YN = u.n2v(data.NEXT_YN, "N");
        return data;
    }

    render() {
        if(!this.$props.COLABO_SRNO) return;

        const $projectTaskReport = $(this.$target).find('.js-widget-article-list');
        if (u.n2v(this.$props.data.TOTAL_CNT, '0') === '0') {
            $projectTaskReport.html(getNoData('task'));
            return;
        }

        $projectTaskReport.drawListHelper({
            pageData: this.$props.pageData,
            records: constants.STATUS_GB.map((v, i) => ({STTS: constants.STTS[i], CNT: this.$props.data[v], PER: this.$props.data[v + "_PER"]})),
            noDataHtml: getNoData('project'),
            callback: {
                item: getProjectTaskReportHtmByRecord,
                final: this.mounted.bind(this)
            }
        })
    }

    mounted() {
        super.mounted();

        $(this.$target).find('.widget-article-list').removeClass('dash-pending').addClass('summary-list')
        $(this.$target).find('.dash-num-pending').remove()
        subscribeWidget({
            USER_ID : _USER_ID,
            COLABO_SRNO : this.$props.COLABO_SRNO,
            TYPE : WIDGET.REPORT.SRNO
        })
    }

    setEvent() {
        addFilterEvent.bind(this)({$w: $(this.$target), filterGb: "report_filter"})
        $(this.$target).off('click').on('click', (e) => {
            const $eTarget = $(e.target);
            const $w = $(this.$target).closest('.widget-project-summary');

            /*차트인포*/
            if ($eTarget.closest(".js-task-chart-info").length > 0) {
                const $summary = $eTarget.closest(".widget-project-summary");
                const TITLE = $summary.find('.title').text();
                const COLABO_SRNO = $summary.attr('colabo_srno');
                const STTS = $eTarget.closest(".js-task-chart-info").attr("data-code")
                LocalUtil.setLocal("TASK_REPORT", STTS);
                LocalUtil.setLocal("TASK_DASHBOARD", this.$props.FIL_END_DT_GUBUN === "2" ? 'myTask' : "");

                //0:요청, 1:진행, 2:완료, 3:보류, 4:피드백
                if (isMobile) {
                    const jsonData = {
                        CODE: "TASK",
                        COLABO_SRNO,
                        STTS,
                        TITLE
                    };
                    BridgeSend(jsonData);
                } else {
                    ViewChanger.loadPageJson({code: "task", first: COLABO_SRNO});
                }
            }
        })
    }

}


/*업무 리포트 아이템 dom으로 변환하여 반환하는 함수*/
const getProjectTaskReportHtmByRecord = (allPostsArray) => {
    return allPostsArray.map((item) => {
        return getTaskReportItem(item)
    }).join('');
}

const getTaskReportItem = (item) => {
    const {
        STTS,
        CNT,
        PER,
    } = item
    return `<li class="js-task-chart-info report-item ${constants.STATUS_GB_CLASS[STTS]}" data-code=${STTS === 5 ? constants.allSTTS : STTS}>
                    <h4>
                        <em>${i18next.t(constants.STATUS_NM[STTS])}</em>
                        <span>${new Intl.NumberFormat().format(CNT)}</span>
                    </h4>
                    ${STTS === 5 ? '' : '<p><span class="js-chart-info-percent">' + PER + '%</span></p>'}
                </li>`
}
